import * as React from 'react';
import { storyblokEditable, type SbBlokData } from '@storyblok/react';

import type { SocialLinkStoryblok } from '../../types/storyblok';
import { SocialIcon, isSupportedPlatform } from '../ui/icons/social/SocialIcon';

interface SocialLinkProps {
  blok: SocialLinkStoryblok;
}

export const SocialLink: React.FC<SocialLinkProps> = ({ blok }) => {
  if (!isSupportedPlatform(blok.platform)) return null;

  return (
    <a
      {...storyblokEditable(blok as unknown as SbBlokData)}
      href={blok.url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 text-neutral-white hover:text-secondary-iceBlue"
    >
      <SocialIcon platform={blok.platform} className="w-6 h-6" />
      <span className="sr-only">{blok.platform}, opens in new tab</span>
      {blok.label && <span>{blok.label}</span>}
    </a>
  );
};
